module.exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "La valeur doit \xEAtre ".concat(args.maxValue, " ou ant\xE9rieure.");
  },
  "rangeReversed": "La date de d\xE9but doit \xEAtre ant\xE9rieure \xE0 la date de fin.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "La valeur doit \xEAtre ".concat(args.minValue, " ou ult\xE9rieure.");
  },
  "unavailableDate": "La date s\xE9lectionn\xE9e n\u2019est pas disponible."
};